<template>
    <div class="transformer">
        <Title firstName="变压器总功率" lastName="TOTAL TRANSFORMER POWER"/>
        <div class="echarts">
            <div class="edata">
                <div class="edataCon">
                    <p>实时总功率</p>
                    <p>{{seriesData1[seriesData1.length - 1] || 0}}<span> kVA</span></p>

                </div>
                <div class="edataCon">
                    <p>变压器容量</p>
                    <p>800<span> kVA</span></p>

                </div>
            </div>
            <div class="eview">
                <Graph :chartId="chartId" :seriesData="seriesData" :seriesData1="seriesData1" :xData="xData" v-if="seriesData.length >0"/>
                <div class="icon"><span></span> 今日 <span></span> 昨日</div>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../components/title/Title')
const Graph = () => import('../../components/echarts/graph.vue')
import { GetAllAreas, GetAllTransformer,GetloopHistorycurve } from '../../components/Request'
export default {
    data(){
        return {
            chartId:'transformer',
            xData:['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00','24:00',],
            seriesData:[],
            seriesData1:[],
            transforms:[]
        }
    },
    components:{
        Title,Graph
    },
    created(){
    },
    mounted(){
        this.getAllTransformer()
    },
    methods:{


        async getAllTransformer(){
            let that = this
            if(this.$store.state.areas.length > 0){
                let areas = this.$store.state.areas

                for(let i=0;i<areas.length;i++){
                    let res = await GetAllTransformer({areaId:areas[i].areaId})
                    if(res.data.data.list.length > 0){
                        res.data.data.list.forEach(val => {
                            that.transforms.push(val)
                        })
                    }
                }
                this.getLoopHistorycurve(this.transforms)
            }
        },
        // 获取变压器的历史曲线
        async getLoopHistorycurve(transforms){
            let time = this.getTodayTime()
            
            let ydata = []
            let ydata1 = []

            for(let i = 0;i<transforms.length;i++){
                let data = {
                    deviceLoopId:transforms[i].loop_id,
                    start : `${time.today}T00:00:00Z`,
                    "node": 'P_1h',
                    end : `${time.today}T24:00:00Z`,
                }
                let res = await GetloopHistorycurve(data)
                let points  = res.data.data.points
                points.forEach(item =>{
                    ydata.push((item.val/1000).toFixed(2))
                })
            }

            for(let i = 0;i<transforms.length;i++){
                let data = {
                    deviceLoopId:transforms[i].loop_id,
                    start : `${time.yesterday}T00:00:00Z`,
                    "node": 'P_1h',
                    end : `${time.yesterday}T24:00:00Z`,
                }
                let res = await GetloopHistorycurve(data)
                let points  = res.data.data.points
                points.forEach(item =>{
                    ydata1.push((item.val/1000).toFixed(2))
                })
            }
            this.seriesData1 = ydata
            this.seriesData = ydata1

        },
        // 获取今天的时间
        getTodayTime(){
            let currentime = new Date()
            let year = currentime.getFullYear()
            let month = currentime.getMonth() + 1
            let day = currentime.getDate()
            // console.log(year,month,day);
            let time = {
                today : this.correction(year) + '-' + this.correction(month) + '-' + this.correction(day),
                yesterday : this.correction(year) + '-' + this.correction(month) + '-' + this.correction(day - 1)
            }
            return time
        },
        // 一位数前补0
        correction(time){
            return time>=0 && time<10 ? '0'+time :time
        },

        

    },
    watch:{
        '$store.state.areas'(val){
            // console.log(val);
            this.getAllTransformer()
        }
    }
}
</script>

<style lang="less" scoped>
    .transformer{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 30.3vh;
        left: 2vw;

        .echarts{
            position: relative;
            height: 28.7vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            .edata{
                height: 9vh;
                display: flex;
                justify-content: space-around;
                padding: 3vh 0;
                .edataCon{
                    position: relative;
                    text-align: center;
                    p:nth-child(1){
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: rgba(230,243,253, 0.7);
                    }
                    p:nth-child(2){
                        padding-top: 3rem;
                        font-size: 20rem;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;
                        color: #00DEFF;
                        span{
                            font-size: 14rem;
                        }
                    }
                }
            }

            .eview{
                width: 100%;
                padding: 0 0.5vw;
                height: 17.9vh;
                position: relative;
                #transformerChart{
                    width: 100%;
                    height: 100%;
                }

                .icon{
                    position: absolute;
                    right: 1vw;
                    top: 0;
                    color: rgba(230,243,253, 0.7);
                    &>span{
                        width: 12rem;
                        height: 12rem;
                        display: inline-block;
                        vertical-align: -1rem;
                        margin-right: 5rem;
                    }
                    &>span:nth-of-type(1){
                        background-color: #f6bd16;
                    }
                    &>span:nth-of-type(2){
                        background-color: #1290ff;
                        margin-left: 5rem;
                    }
                }
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>